const inputCapOptions = [
  {
    "key": "UNKNOWN",
    "text": "Unknown"
  },
  {
    "key": "MANUAL",
    "text": "Manual"
  },
  {
    "key": "MAGNETIC_STRIPE",
    "text": "Magnetic stripe"
  },
  {
    "key": "BARCODE_OR_QR",
    "text": "Barcode or qr"
  },
  {
    "key": "OCR",
    "text": "Ocr"
  },
  {
    "key": "ICC",
    "text": "Icc"
  },
  {
    "key": "KEY_ENTERED",
    "text": "Key entered"
  },
  {
    "key": "FILE",
    "text": "File"
  },
  {
    "key": "CONTACTLESS_READ_VIA_MAG_STRIPE_RULES",
    "text": "Contactless read via mag stripe rules"
  },
  {
    "key": "CONTACTLESS_READ_VIA_CHIP_RULES",
    "text": "Contactless read via chip rules"
  },
  {
    "key": "MAG_STRIPE_AND_KEY_ENTRY",
    "text": "Mag stripe and key entry"
  },
  {
    "key": "MAG_STRIPE_AND_KEY_ENTRY_AND_EMV",
    "text": "Mag stripe and key entry and emv"
  },
  {
    "key": "MAG_STRIPE_AND_EMV",
    "text": "Mag stripe and and emv"
  },
  {
    "key": "SECURE_CARDLESS_ENTRY",
    "text": "Secure cardless entry"
  }
]

export default inputCapOptions;